module.exports = __webpack_public_path__ + "static/media/intro_4.5c008120.svg";